
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class LogoSvg extends Vue {
  @Prop({ type: String, default: "24" }) width!: string
  @Prop({ type: String, default: "24" }) height!: string
  @Prop({ type: String, default: "#8C8C8C" }) iconColor!: string
}
